import styled from 'styled-components';

export const ProfileDetails = styled.div`
  @media (min-width: 1024px) {
    max-width: 60%;
  }
`;
